'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectBoxCustom = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleTooltipIcon = require('reactackle-tooltip-icon');

var _reactackleAutoposition = require('reactackle-autoposition');

var _reactackleCore = require('reactackle-core');

var _OptionPropTypeCustom = require('../OptionPropType/OptionPropTypeCustom');

var _OptionsListCustom = require('../OptionsListCustom/OptionsListCustom');

var _SelectBoxCustomStyled = require('./styles/SelectBoxCustomStyled');

var _ContentBoxStyled = require('../styles/ContentBoxStyled');

var _WrapperStyled = require('../styles/WrapperStyled');

var _ButtonStyled = require('./styles/ButtonStyled');

var _ButtonTextStyled = require('./styles/ButtonTextStyled');

var _ArrowIconStyled = require('./styles/ArrowIconStyled');

var _SelectBoxStyled = require('../styles/SelectBoxStyled');

var _SelectBoxLabelStyled = require('../styles/SelectBoxLabelStyled');

var _SelectBoxLabelTextStyled = require('../styles/SelectBoxLabelTextStyled');

var _SelectBoxInfoBoxStyled = require('../styles/SelectBoxInfoBoxStyled');

var _MessageStyled = require('../styles/MessageStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  /**
   * Determines whether SelectBox is full width
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Determines dense of the SelectBox
   */
  dense: _propTypes2.default.bool,
  /**
   * Determines whether SelectBox is disabled
   */
  disabled: _propTypes2.default.bool,
  /**
   * Default value of the SelectBox
   */
  defaultValue: _propTypes2.default.any,
  /**
   * Value of the SelectBox
   */
  value: _propTypes2.default.any,
  /**
   * Reverse options list
   */
  reverse: _propTypes2.default.bool,
  /**
   * Define help or error message
   */
  message: _propTypes2.default.string,
  /**
   * Determines placeholder of the SelectBox
   */
  placeholder: _propTypes2.default.string,
  /**
   * Tooltip text of the SelectBox
   */
  tooltip: _propTypes2.default.string,
  /**
   * Label text of the SelectBox
   */
  label: _propTypes2.default.string,
  /**
   * Specify maximum amount of options, visible at the same time without
   * scrolling
   */
  maxOptionsVisible: _propTypes2.default.number,
  /**
   * Determines label position
   */
  labelPosition: _propTypes2.default.oneOf(['top', 'side']),
  /**
   * Determines whether SelectBox is bordered
   */
  bordered: _propTypes2.default.bool,
  /**
   * Color scheme of the SelectBox
   */
  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * Determines options of the SelectBox
   */
  options: _propTypes2.default.arrayOf(_OptionPropTypeCustom.OptionPropTypeCustom),
  /**
   * Specify function to call on SelectBox value change
   */
  onChange: _propTypes2.default.func
};

var defaultProps = {
  fullWidth: false,
  dense: false,
  disabled: false,
  defaultValue: void 0,
  value: void 0,
  reverse: false,
  message: '',
  placeholder: '',
  label: '',
  labelPosition: 'top',
  tooltip: '',
  bordered: false,
  colorScheme: 'neutral',
  options: [],
  onChange: _reactackleCore.noop,
  maxOptionsVisible: 5
};

var openSelectBox = null;

var clickHandler = function clickHandler(event) {
  if (openSelectBox) {
    var listDOMNode = openSelectBox._optionsList;
    if (listDOMNode && !listDOMNode.contains(event.target)) openSelectBox.close();
  }
};

var KEYS = {
  SPACE: 32,
  DOWN_ARROW: 40,
  UP_ARROW: 38
};

var customSelectBoxesNum = 0;
var nextId = 0;

var _SelectBoxCustom = function (_Component) {
  _inherits(_SelectBoxCustom, _Component);

  function _SelectBoxCustom(props) {
    _classCallCheck(this, _SelectBoxCustom);

    var _this = _possibleConstructorReturn(this, (_SelectBoxCustom.__proto__ || Object.getPrototypeOf(_SelectBoxCustom)).call(this, props));

    _this.state = {
      id: 'select-box-' + nextId++,
      value: (0, _reactackleCore.isUndef)(props.value) ? props.defaultValue : props.value,
      open: false,
      onTop: false,
      checkOverflowHeight: false
    };

    _this._optionsList = null;
    _this._listWrapper = null;
    _this._handleChange = _this._handleChange.bind(_this);
    _this._createListRef = _this._createListRef.bind(_this);
    _this._handleKeyDown = _this._handleKeyDown.bind(_this);
    _this._handleLinkClick = _this._handleLinkClick.bind(_this);
    _this._handleWrapperClick = _this._handleWrapperClick.bind(_this);
    _this.open = _this.open.bind(_this);
    _this.close = _this.close.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this._createListWrapperRef = _this._createListWrapperRef.bind(_this);
    return _this;
  }

  _createClass(_SelectBoxCustom, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!customSelectBoxesNum) window.addEventListener('click', clickHandler, false);

      customSelectBoxesNum++;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value && (0, _reactackleCore.isUndef)(nextProps.value)) {
        this.setState({
          value: this.props.value
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      customSelectBoxesNum--;

      if (!customSelectBoxesNum) window.removeEventListener('click', clickHandler, false);
    }
  }, {
    key: '_createListRef',
    value: function _createListRef(ref) {
      this._optionsList = ref;
    }
  }, {
    key: '_createListWrapperRef',
    value: function _createListWrapperRef(ref) {
      this._listWrapper = ref;
    }
  }, {
    key: '_getCurrentValue',
    value: function _getCurrentValue() {
      return (0, _reactackleCore.isUndef)(this.props.value) ? this.state.value : this.props.value;
    }
  }, {
    key: '_handleLinkClick',
    value: function _handleLinkClick() {
      this.open();
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.state.open) this.close();else this._handleLinkClick();
    }
  }, {
    key: 'open',
    value: function open() {
      if (this.props.disabled || this.state.open) return;
      this.setState({
        open: true
      });

      if (openSelectBox) openSelectBox.close();
      openSelectBox = this;
    }
  }, {
    key: 'close',
    value: function close() {
      if (!this.state.open) return;

      this.setState({
        open: false
      });

      openSelectBox = null;
    }
  }, {
    key: '_handleChange',
    value: function _handleChange(_ref) {
      var value = _ref.value;

      var newState = {
        open: false
      };

      openSelectBox = null;

      if ((0, _reactackleCore.isUndef)(this.props.value)) newState.value = value.value;

      this.setState(newState);

      this.props.onChange({
        value: value.value
      });
    }
  }, {
    key: '_handleWrapperClick',
    value: function _handleWrapperClick(event) {
      event.stopPropagation();
    }
  }, {
    key: '_handleKeyDown',
    value: function _handleKeyDown(e) {
      if (e.keyCode === KEYS.SPACE) {
        this._handleLinkClick();
        e.preventDefault();
      }
    }
  }, {
    key: '_renderLabel',
    value: function _renderLabel() {
      var tooltip = this.props.tooltip ? _react2.default.createElement(_reactackleTooltipIcon.TooltipIcon, { text: this.props.tooltip }) : null;

      return _react2.default.createElement(
        _SelectBoxLabelStyled.SelectBoxLabelStyled,
        {
          htmlFor: this.state.id,
          dense: this.props.dense,
          fullWidth: this.props.fullWidth,
          labelPosition: this.props.labelPosition,
          bordered: this.props.bordered,
          disabled: this.props.disabled,
          colorScheme: this.props.colorScheme,
          focus: this.state.open
        },
        _react2.default.createElement(
          _SelectBoxLabelTextStyled.SelectBoxLabelTextStyled,
          null,
          this.props.label
        ),
        tooltip
      );
    }
  }, {
    key: '_renderMessage',
    value: function _renderMessage() {
      if (!this.props.message) return null;

      return _react2.default.createElement(
        _SelectBoxInfoBoxStyled.SelectBoxInfoBoxStyled,
        {
          dense: this.props.dense,
          fullWidth: this.props.fullWidth,
          labelPosition: this.props.labelPosition,
          bordered: this.props.bordered,
          disabled: this.props.disabled
        },
        _react2.default.createElement(
          _MessageStyled.MessageStyled,
          {
            colorScheme: this.props.colorScheme,
            disabled: this.props.disabled,
            focus: this.state.open
          },
          this.props.message
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.reverse ? [].concat(_toConsumableArray(this.props.options)).reverse() : this.props.options;

      var value = this._getCurrentValue(),
          hasValue = !(0, _reactackleCore.isUndef)(value) && value !== null;

      var selectedItem = hasValue ? data.find(function (item) {
        return item.value === value;
      }) : null;

      var text = hasValue && selectedItem ? selectedItem.text : this.props.placeholder;

      var label = this._renderLabel(),
          message = this._renderMessage();

      return _react2.default.createElement(
        _SelectBoxStyled.SelectBoxStyled,
        null,
        _react2.default.createElement(
          _SelectBoxCustomStyled.SelectBoxCustomStyled,
          { onClick: this._handleWrapperClick },
          _react2.default.createElement(
            _ContentBoxStyled.ContentBoxStyled,
            { labelPosition: this.props.labelPosition },
            label,
            _react2.default.createElement(
              _WrapperStyled.WrapperStyled,
              { innerRef: this._createListWrapperRef },
              _react2.default.createElement(
                _ButtonStyled.ButtonStyled,
                {
                  fullWidth: this.props.fullWidth,
                  dense: this.props.dense,
                  bordered: this.props.bordered,
                  disabled: this.props.disabled,
                  focused: this.state.open,
                  colorScheme: this.props.colorScheme,
                  tabIndex: 0,
                  onClick: this._handleLinkClick,
                  onKeyDown: this._handleKeyDown
                },
                _react2.default.createElement(
                  _ButtonTextStyled.ButtonTextStyled,
                  {
                    dense: this.props.dense,
                    fullWidth: this.props.fullWidth,
                    bordered: this.props.bordered
                  },
                  text
                ),
                _react2.default.createElement(
                  _ArrowIconStyled.ArrowIconStyled,
                  {
                    fullWidth: this.props.fullWidth,
                    dense: this.props.dense,
                    disabled: this.props.disabled,
                    focused: this.state.open,
                    colorScheme: this.props.colorScheme
                  },
                  this.props.theme.reactackle.components.selectBox.icon.element
                )
              ),
              _react2.default.createElement(
                _reactackleAutoposition.AutoPosition,
                {
                  parent: this._listWrapper,
                  positionX: 'left',
                  positionY: 'top',
                  type: 'inner',
                  direction: 'vertical',
                  visible: this.state.open
                },
                _react2.default.createElement(_OptionsListCustom.OptionsListCustom, {
                  createListRef: this._createListRef,
                  options: data,
                  selectedItem: selectedItem,
                  placeholder: this.props.placeholder,
                  maxLines: this.props.maxOptionsVisible,
                  onChange: this._handleChange
                })
              )
            )
          ),
          message
        )
      );
    }
  }]);

  return _SelectBoxCustom;
}(_react.Component);

_SelectBoxCustom.propTypes = propTypes;
_SelectBoxCustom.defaultProps = defaultProps;
_SelectBoxCustom.displayName = 'SelectBoxCustom';

var SelectBoxCustom = exports.SelectBoxCustom = (0, _reactackleCore.withTheme)(_SelectBoxCustom);


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-selectbox/dist/SelectBoxCustom/SelectBoxCustom.js
// module id = 789
// module chunks = 0